<script setup>
	import { defineProps, defineEmits, onMounted } from 'vue'
    import Chat from '../Chat.vue'

	const props = defineProps({
		question: {
			type: Object,
			required: true
		}
	})
    const emit = defineEmits(['proceed'])

    console.log(props.question)

    let called = false
    function delaySubmit() {
        called = true
        setTimeout(onSubmit, 8000);
    }

    function onSubmit() {
        emit('proceed', called);
    }

    onMounted(() => {
        console.log('mounted')
    })
</script>

<template>
    <section class="btn-options">
        <h3 class="questionHeading">{{ question.headline }}</h3>
        <!-- <h5 class="questionSubHeading">{{ question.headline }}</h5> -->
        <p class="subText" v-if="question.subHeadline">{{ question.subHeadline }}</p>

        <!-- <p class="subText">Call the number below to verify your eligibility now.</p> -->

        <a class="btn btn-primary" :href="'tel:' + question.number" @click="delaySubmit"><i class="fa-solid fa-phone" style="color: #ffffff;"></i> {{question.prettyNumber}}</a>

        <p class="no-thanks-link">
            <a href="#" @click.prevent="onSubmit">No thanks, I'm not interested.</a>
        </p>

        <div v-if="question.chat">
            <Chat :message="question.chat" />
        </div>
    </section>
</template>

<style scoped>
    .btn-options {
        min-height: 65vh;
        position: relative;
    }
    .questionHeading {
        font-size: 1.5em;
        font-weight: 700;
        color: #2a2a2b;
        text-align: center;
        line-height: 1.2;
        margin-bottom: 15px;
    }

    .questionPreHeading {
        color: #19329a;
        font-style: italic;
        font-size: .9em;
        font-weight: 600;
        text-align: center;
        margin-bottom: 10px;
    }

    .questionSubHeading {
        font-size: 1.1em;
        font-weight: 600;
        text-align: center;
        margin-bottom: 21px;
        line-height: 1.5;
    }

    .subText {
        font-size: 1em;
        font-weight: 400;
        text-align: center;
        line-height: 1.5;
    }

    .btn-primary {
        background-color: #f9892a;
        border-color: #f9892a;
        padding: 15px 42px;
        font-size: 1.4em;
        font-weight: 700;
        border-radius: 32px;
        display: block;
        width: 100%;
        margin-top: 40px;
        transition: all .3s ease;
        box-shadow: 0 10px 15px #f9892a4d;
        margin-bottom: 20px;
    }

    .btn-primary:disabled {
        /* background-color: #ddd;
        border-color: #efefef; */
        box-shadow: none;
    }

    .form-control {
        border-color: #ccc;
        border-radius: 3px;
        box-shadow: 0 3px 0 #dbdBE866;
        position: relative;
        padding-left: 18px;
        height: 70px;
    }

    .form-floating>label {
        padding-left: 20px;
        color: #ccc;
        padding-top: 1.2rem;
    }

    .form-floating>.form-control:focus~label,
    .form-floating>.form-control:not(:placeholder-shown)~label {
        transform: scale(.75) translateY(-.5rem) translateX(.25rem);
    }

    .form-control:active,
    .form-control:focus,
    .form-control:hover {
        border-width: 2px;
        border-color: #f9892a;
        border-style: solid;
    }

    .disclaimer {
        font-size: .6em;
        line-height: 1.5;
        text-align: center;
        margin-top: 30px;
    }

    .no-thanks-link {
        text-align: center;
        margin-top: 10px;
        font-size: 0.9em;
    }

    .no-thanks-link a {
        color: #007bff;
        text-decoration: underline;
        cursor: pointer;
    }

    @media (min-width: 551px) {
        
    }
</style>